import { createRouter, createWebHistory } from 'vue-router';
import BetForcast from './components/BetForcast.vue';
import BetResults from './components/BetResults.vue';
import FrameView from './components/FrameView.vue';
const routes = [
  { path: '/', component: BetForcast },
  { path: '/:lang', component: BetForcast, props: true },
  { path: '/results', component: BetResults },
  {path:'/frame/:lang',component:FrameView, props: true},

];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
